const PROJECTS_DATA = [
    {
        id: 1,
        name: "POLICE STATION",
        link: "https://rsp262610.netlify.app/",
        image: "/images/1.png",
        tags: ["#CONDITIONS", "#FUNCTIONS", "#VANILLAJS"],
        head: "it is the rock paper scissor game made with HTML, CSS, JS, learned conditional rendering and some routing in vanilla",
    },
    {
        id: 2,
        name: "CITY",
        link: "https://bankist-mr.netlify.app/",
        image: "/images/2.png",
        tags: ["#ARRAYS", "#FUNCTIONS", "#VANILLAJS", "#AUTH"],
        head: "it is the bank application named BANKIST, learned a lot about arrays and their important methods"
    },
    {
        id: 3,
        name: "CITY BLACK",
        link: "https://joke-teller-mr.netlify.app/",
        image: "/images/3.png",
        tags: ["#API", "#JOKE", "#SPEECHTOTEXT", "#JSON"],
        head: "joke teller application made with Javascript, learned a lot about APIs, it also include TEXT TO SPEECH API",
    },
    {
        id: 4,
        name: "HOSPITAL",
        link: "https://mukulrajpoot.netlify.app/",
        image: "/images/4.png",
        tags: ["#JS", "#CSS", "#ANIMATIONS", "#SPA"],
        head: "It is my Personal Portfolio website made with REACTJS, learned a lot about parallax, some CSS animations and advanced DOM manipulation"
    },
    {
        id: 5,
        name: "HOSPITAL BLACK",
        link: "https://trackit-mr.netlify.app/",
        image: "/images/5.png",
        tags: ["#JS", "#API", "#WEATHER", "#COVID", "#NEWS"],
        head: "It is biggest Application made with VANILLA JS, learned a lot about APIs, including MAP, handle CORS and some JS routing"
    },
    {
        id: 6,
        name: "LIGHT HOUSE",
        link: "https://fortynine-mr.netlify.app/",
        image: "/images/6.png",
        tags: ["#SPA", "#REACT"],
        head: "It is the simple single page website made with REACT to practice basic components and Routing in DOM"
    },
    {
        id: 7,
        name: "NIGHT BEDROOM",
        link: "https://vegshop-mr.netlify.app/",
        image: "/images/7.png",
        tags: ["#ECOMMERCE", "#REACT", "#CONTEXT", "#REDUCER"],
        head: "It is the complete E-commerce application made with REACT and CONTEXT, learned a lot about state management"
    },
    {
        id: 8,
        name: "ROOM",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/8.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 9,
        name: "RABBIT RAIDER",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/9.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 10,
        name: "LAMP",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/10.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 11,
        name: "EGYPT",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/11.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 12,
        name: "MODERN HOUSE",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/12.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 13,
        name: "SWEET HOME",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/13.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 14,
        name: "OFFICE",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/14.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 15,
        name: "SMALL SHOP",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/15.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 16,
        name: "CHARACTER",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/16.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 17,
        name: "SPORTS CAR",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/17.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
    {
        id: 18,
        name: "BOAT",
        link: "https://housemart-mr.netlify.app/",
        image: "/images/19.png",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
]

export default PROJECTS_DATA